var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c(
          "h5",
          { staticClass: "modal-title", attrs: { id: "newBarModalLabel" } },
          [_vm._v("Add New bar")]
        ),
        _c("button", {
          staticClass: "btn-close",
          attrs: { type: "button", "data-bs-dismiss": "modal" },
          on: { click: _vm.clear },
        }),
      ]),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "mt-3" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "BarName" } },
            [_vm._v("Bar Name")]
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name",
              },
            ],
            staticClass: "form-control pl-3",
            attrs: {
              type: "text",
              id: "BarName",
              "aria-describedby": "emailHelp",
            },
            domProps: { value: _vm.name },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.name = $event.target.value
              },
            },
          }),
        ]),
        _c("div", { staticClass: "mt-3" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "Details" } },
            [_vm._v("Bar Details")]
          ),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.clubDetails,
                expression: "clubDetails",
              },
            ],
            staticClass: "form-control pl-3",
            attrs: {
              placeholder: "Leave a comment here",
              id: "floatingTextarea",
            },
            domProps: { value: _vm.clubDetails },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.clubDetails = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false",
              },
            ],
            ref: "close",
            staticClass: "btn btn-secondary",
            attrs: { type: "button", "data-bs-dismiss": "modal" },
          },
          [_vm._v("Close")]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: { type: "button", "data-bs-dismiss": "modal" },
            on: { click: _vm.clear },
          },
          [_vm._v("Close")]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.saveItem()
              },
            },
          },
          [_vm._v("Save changes")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }